import React from 'react';
import { I18n } from 'react-redux-i18n';
import ARTSPreviewCharts from './ARTSChartsPreview';
import './ARTSPreview.scss';

const buildTexts = () => ({
  donutTitle: I18n.t('dashboard.artsDonutTitle'),
  scatterTitle: I18n.t('dashboard.artsScatterTitle'),
  heatmapTitle: I18n.t('dashboard.artsHeatmapTitle'),
  intensityLabel: I18n.t('dashboard.artsIntensityLabel'),
  scaleLow: I18n.t('dashboard.artsScaleLow'),
  scaleHigh: I18n.t('dashboard.artsScaleHigh'),
  profiles: I18n.t('dashboard.profiles'),
  person: I18n.t('dashboard.artsPerson'),
  persons: I18n.t('dashboard.artsPersons'),
  usersWithProfile: I18n.t('dashboard.artsUsersWithProfile'),
  artsLabels: {
    A: I18n.t('dashboard.artsLabels.A'),
    R: I18n.t('dashboard.artsLabels.R'),
    T: I18n.t('dashboard.artsLabels.T'),
    S: I18n.t('dashboard.artsLabels.S'),
  },
});

const ARTSPreview = ({ artsDistribution, artsDistributionStatus }) => {
  const texts = buildTexts();

  return (
    <section className="arts-preview-section">
      <ARTSPreviewCharts
        texts={texts}
        artsDistribution={artsDistribution}
        artsDistributionStatus={artsDistributionStatus}
      />
    </section>
  );
};

export default ARTSPreview;
